import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form-mui';

import { useGetOcrData, useUpdateOcrData } from 'src/use-cases/internalDashboard/useFileResolution';
import { ROW_ACTION_TYPE, TUpdateValues } from './types';
import { ModalUpdateBase } from './ModalUpdateBase';
import { FormEditOcrData } from './FormEditOcrData.tsx';
import { useInternalDashboardSelector } from './Selector';
import { openToastError } from '../../../../use-cases/toast/useToast.tsx';

const actionType = ROW_ACTION_TYPE.EDIT_OCR;
const defaultValues = {
  ocrData: '',
};

export const ModalEditOcrData = () => {
  const formContext = useForm({
    defaultValues: defaultValues as TUpdateValues,
  });

  const [ocrMessage, setOcrMessage] = useState<string>('');
  const { selectedRow, rowActionType, setIsActionLoading, stopRowAction, checkRowAction } = useInternalDashboardSelector();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isOpen = useMemo(() => checkRowAction(actionType), [rowActionType]);

  const { data } = useGetOcrData(selectedRow?.invoiceFileProcessingId, isOpen);

  useEffect(() => {
    if (data) {
      setOcrMessage(JSON.stringify(data, null, 2));
    } else {
      setOcrMessage('');
    }
  }, [data, setOcrMessage]);

  const { mutateAsync: update } = useUpdateOcrData(selectedRow?.invoiceFileProcessingId);

  const onSubmitForm = async (values: TUpdateValues) => {
    setIsActionLoading(true);

    try {
      await update(JSON.parse(values.ocrData || {}));
    } catch (error) {
      if (error instanceof Error) {
        openToastError(error);
      } else {
        openToastError(new Error('An unknown error occurred'));
      }
      setIsActionLoading(false);
      return;
    }

    setIsActionLoading(false);
    stopRowAction();
  };

  return (
    <ModalUpdateBase title='Edit OCR Data' actionType={actionType} formContext={formContext} onSubmit={onSubmitForm}>
      <div className='relative'>
        <FormEditOcrData ocrMessage={ocrMessage} />
      </div>
    </ModalUpdateBase>
  );
};
